var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70742 0.339204L4.79225 0.333496C5.10867 0.333496 5.37017 0.568621 5.4115 0.873688L5.41725 0.958496L5.4165 11.5385L8.09934 8.85416C8.32117 8.63225 8.66842 8.61191 8.91317 8.79333L8.98325 8.85383C9.20525 9.07558 9.22558 9.42283 9.04408 9.66758L8.98367 9.73775L5.23675 13.4877C5.015 13.7097 4.66775 13.73 4.423 13.5486L4.35292 13.4881L0.599744 9.73808C0.355569 9.49408 0.355402 9.09841 0.599377 8.85416C0.821168 8.63225 1.16839 8.61191 1.41314 8.79333L1.48326 8.85383L4.1665 11.5352L4.16725 0.958496C4.16725 0.642079 4.40234 0.380588 4.70742 0.339204Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9916e131b8ff9392693c2948abec15a8.svg";
export { ForwardRef as ReactComponent };